export default __webpack_public_path__ + "static/facilitators-d5c7832e502cad4d9ae311aa1c349b78.jpg";